import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import {
    BrowserRouter as Router,
    Switch,
    Route
} from "react-router-dom";
import { makeStyles, ThemeProvider } from "@material-ui/core/styles";

import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import theme from '../../theme';

import ApprovalForm from './ApprovalForm';
import ApprovalTerms from './ApprovalTerms';


const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
        margin: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            margin: 12,
            '&>div': {
                paddingLeft: 0,
                paddingRight: 0
            },
        },
    },
}));


const ApprovalFormWrapper = (props) => {
    const { wedding } = props;

    useEffect(() => {
        document.title = `Approval Form - Enduring Promises`;
    });

    return (
        <ApprovalForm wedding={wedding} />
    );
}

const ApprovalTermsWrapper = (props) => {
    const { wedding } = props;

    useEffect(() => {
        document.title = `Approval Terms - Enduring Promises`;
    });

    return (
        <ApprovalTerms wedding={wedding} />
    )
}

const ApprovalThankYou = (props) => {
    const { setWelcomeText } = props;

    useEffect(() => {
        document.title = `Thank You - Enduring Promises`;
        setWelcomeText('Thank You');
    });

    /* TODO: get this text from LeadSetting */

    return (
        <div align="center">
            Thank you for approving your Wedding Ceremony Contract and Couple&#39;s Information Form.
            <br />An email of these documents has been sent to you for your records.
        </div>
    );
}

const Home = () => {
    const wedding = window.wedding;
    const classes = useStyles();

    const [welcomeText, setWelcomeText] = React.useState('Welcome');

    return (
        <ThemeProvider theme={theme}>
            <Router>
                <div className={classes.root}>
                    <Container maxWidth='xl'>
                        <Grid container spacing={1}>
                            <Grid item xs={12} align="center">
                                <Typography style={{marginBottom: 10, marginBottom: 0}}>
                                    <img src="/img/ep-logo-sm-v2.png" style={{ maxWidth: '240px' }} />
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography align="center" variant="h5" color="textPrimary" style={{marginBottom: 10, marginBottom: 30}}>
                                    {welcomeText} {wedding.bride_first_name} & {wedding.groom_first_name}
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid
                            container
                            direction="row"
                            justify="center"
                            alignItems="center"
                        >
                            <Grid item xs={12}>
                                <Switch>
                                    <Route path="/approval/form">
                                        <ApprovalFormWrapper wedding={wedding} />
                                    </Route>
                                    <Route exact path="/approval/terms">
                                        <ApprovalTermsWrapper wedding={wedding} />
                                    </Route>
                                    <Route exact path="/approval/thank-you">
                                        <ApprovalThankYou setWelcomeText={setWelcomeText} />
                                    </Route>
                                </Switch>
                            </Grid>
                        </Grid>
                    </Container>
                </div>
            </Router>
        </ThemeProvider>
    );
}



if (document.getElementById('approvals-root')) {
    ReactDOM.render(<Home />, document.getElementById('approvals-root'));
    window._token = document.getElementsByName("csrf-token")[0].content;
}
